import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { ReligiousInfoVO, ConsecratedPersonResponse, SearchVO, SearchResponseVO, HouseNameSearchVO, HouseNameResponse,  HouseNameVO } from '../model/consecratedPerson';
import { DateTimeFormatPipe } from '../pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from './http-error-handler.service';
import { ApiResponse } from '../model/apiresponse';
import { CommunitySearchVO, CommunityResponse, CommunityVO } from '../model/Community';


@Injectable()
export class ConsercatedPersonService {

    public consecratedPerson: ReligiousInfoVO;
    public houseVO:HouseNameVO;
    public communityVO:CommunityVO;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
  houseNameSearchVO: any;
    communitySearchVO: any;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('ConsercatedPersonService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    consecratedPersonInfoInit() {
        this.consecratedPerson = new ReligiousInfoVO();
    }

    getPlaceOfMinistryList(): Observable<any> {
        return this._http.get<any>(
            environment.getPlaceOfMinistryListUrl + "?dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(
                catchError(this.handleError('getPlaceOfMinistryList', []))
            );
    }

    getConsecratedPersonById(personId: number, userName: string): Observable<any> {
        return this._http.get<any>(
            environment.getConsecratedPersonByIdUrl + personId + "?dateParam=" + this.dtformat.transform(new Date, "") + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getConsecratedPersonById', []))
            );
    }

    getConsecratedLifeTypeList(): Observable<any> {
        return this._http.get<any>(
            environment.getConsecratedLifeTypeListUrl + "?dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(
                catchError(this.handleError('getConsecratedLifeTypeList', []))
            );
    }

    getCommunityInformation(communitySearchVO:CommunitySearchVO): Observable<CommunityResponse> {
        return this._http.post<any>(
            environment.getCommunityInformationUrl,communitySearchVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('getCommunityInformation', []))
            );
    }

    getCommunityCount(communitySearchVO:CommunitySearchVO): Observable<number> {
        return this._http.post<any>(
            environment.getCommunityCountUrl,communitySearchVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('getCommunityCount', []))
            );
    }
   
    getCommunityById(id: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.getCommunityByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getCommunityById', []))
                );
    }
    
    postCommunityInfo(communityVO:CommunityVO): Observable<CommunityResponse> {
        return this._http.post<any>(
            environment.postCommunityInfoUrl, communityVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('postCommunityInfo', []))
            );

    }

    deleteCommunityById(id: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.deleteCommunityByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deleteCommunityById', []))
                );
    }

    getHouseNameInformation(houseNameSearchVO:HouseNameSearchVO): Observable<HouseNameResponse> {
        return this._http.post<any>(
            environment.getHouseNameInformationUrl ,houseNameSearchVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('getHouseNameInformation', []))
            );
    }

    postHouseNameInformation(houseVO: HouseNameVO): Observable<HouseNameVO> {
        return this._http.post<any>(
            environment.postHouseNameInformationUrl, houseVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('postHouseNameInformation', []))
            );

    }

    deleteHouseById(id: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.deleteHouseByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deleteHouseById', []))
                );
    }

    getHouseNameById(id: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.getHouseNameByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getHouseNameById', []))
                );
    }



    consercatedPersonInfoSave(consecratedPerson: ReligiousInfoVO): Observable<ConsecratedPersonResponse[]> {
        return this._http.post<ConsecratedPersonResponse[]>(environment.consercatedPersonInfoSaveURL, this.consecratedPerson, this.httpOptions).pipe(
            catchError(this.handleError('personInfoSave()', [])));
    }

    getLocalSuperior(): Observable<any> {
        return this._http.get<any>(
            environment.getLocalSuperiorUrl + "?dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(
                catchError(this.handleError('getLocalSuperior', []))
            );
    }

    getMajorSuperiorInfo(): Observable<any> {
        return this._http.get<any>(
            environment.getMajorSuperiorInfoUrl + "?dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(
                catchError(this.handleError('getMajorSuperiorInfo', []))
            );
    }

    getSatusInfo(): Observable<any> {
        return this._http.get<any>(
            environment.getSatusInfoUrl + "?dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(
                catchError(this.handleError('getMajorSuperiorInfo', []))
            );
    }
    getConsecratedPersons(search: SearchVO): Observable<SearchResponseVO[]> {
        return this._http.post<SearchResponseVO[]>(environment.getConsecratedPersons, search, this.httpOptions).pipe(
            catchError(this.handleError('getConsecratedPersons()', [])));
    }
    getConsecratedPersonsCount(search: SearchVO): Observable<SearchResponseVO[]> {
        return this._http.post<SearchResponseVO[]>(environment.getConsecratedPersons + "/count", search, this.httpOptions).pipe(
            catchError(this.handleError('getConsecratedPersonsCount()', [])));
    }

    exportConsecratedPersonInfo(search: SearchVO): Observable<ConsecratedPersonResponse[]> {
        return this._http.post<ConsecratedPersonResponse[]>(environment.exportConsecratedPersonInfo , search, this.httpOptions).pipe(
            catchError(this.handleError('getConsecratedPersonsCount()', [])));
    }
    
}